export const SNAPPY_RECOVERY_SNAP_ID = window.location.origin.startsWith('http://localhost') ? 'local:http://localhost:8080/' : 'npm:@snappy-recovery/snap';
